import { render, staticRenderFns } from "./sluserinvite-add-or-update.vue?vue&type=template&id=d946ba06&"
import script from "./sluserinvite-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sluserinvite-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports